<div class="cont">
  <div class="screenN">
    <div class="keyGroupN">
      <input
        id="textScreen"
        #keyValue
        class="textScreen"
        NumbersOnly
        (focus)="$event.target.select()"
        [(ngModel)]="elementValue"
        type="text"
      />
    </div>
    <div class="keyGroupN">
      <button class="regularKeyN" (click)="addChar(keyboard.keys['7'])">
        {{ keyboard.keys["7"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['8'])">
        {{ keyboard.keys["8"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['9'])">
        {{ keyboard.keys["9"] }}
      </button>
      <button class="regularKeyN" (click)="onCancel()">Close</button>
    </div>
    <div class="keyGroupN">
      <button class="regularKeyN" (click)="addChar(keyboard.keys['4'])">
        {{ keyboard.keys["4"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['5'])">
        {{ keyboard.keys["5"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['6'])">
        {{ keyboard.keys["6"] }}
      </button>
      <button class="regularKeyN" (click)="onCe()">CE</button>
    </div>
    <div class="keyGroupN num-cont">
      <button class="regularKeyN" (click)="addChar(keyboard.keys['1'])">
        {{ keyboard.keys["1"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['2'])">
        {{ keyboard.keys["2"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['3'])">
        {{ keyboard.keys["3"] }}
      </button>
      <button class="x2KeyN" (click)="onEnterClick()">OK</button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['negative'])">
        {{ keyboard.keys["negative"] }}
      </button>
      <button class="regularKeyN" (click)="addChar(keyboard.keys['0'])">
        {{ keyboard.keys["0"] }}
      </button>
      <button
        class="regularKeyN"
        [disabled]="elementValue.includes('.')"
        (click)="addChar(keyboard.keys['dot'])"
      >
        {{ keyboard.keys["dot"] }}
      </button>
    </div>
  </div>
</div>
